import { FC } from 'react';
import { MyLink as Link } from '@ui-kit/MyLink';
import { Button } from '@ui-kit/MyButton';
import { TypeLinkButton } from './TypeProps';

export const LinkButton: FC<TypeLinkButton> = props => {
  const { children, href, disabled } = props;
  return (
    <Link href={href} disabled={disabled}>
      <Button {...props}>{children}</Button>
    </Link>
  );
};
